"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCheckmarkStyle = getCheckmarkStyle;
exports.getInputStyle = getInputStyle;
exports.getLabelStyle = getLabelStyle;
exports.getOverrides = getOverrides;
exports.getRootStyle = getRootStyle;

var _style = require("../utils/style");

function getCheckmarkStyle({
  $checked: checked,
  $disabled: disabled,
  $isError: errored,
  $isHovered: hovered,
  $isFocused: focused,
  $theme: theme,
  size
}) {
  const length = {
    small: '0.75rem',
    standard: '1.25rem',
    large: '1.5rem'
  }[size];
  const commonStyles = { ...(0, _style.buildBorderRadiusStyle)('1.666667px'),
    ...(0, _style.buildBorderStyle)('Width', '1px'),
    padding: '0.125rem',
    outline: focused ? '5px auto #276ddd' : '',
    width: length,
    height: length
  };

  if (disabled) {
    return {
      backgroundColor: theme.colors.grey10,
      ...commonStyles
    };
  }

  if (errored) {
    return {
      backgroundColor: checked ? theme.colors.primary400 : theme.colors.grey10,
      ...(0, _style.buildBorderStyle)('Color', theme.colors.negative400),
      ...commonStyles
    };
  }

  if (checked) {
    return {
      backgroundColor: hovered ? theme.colors.primary300 : theme.colors.primary400,
      backgroundOrigin: 'content-box',
      ...commonStyles
    };
  }

  return { ...(0, _style.buildBorderStyle)('Color', hovered ? theme.colors.grey90 : theme.colors.grey50),
    backgroundColor: theme.colors.grey10,
    ...commonStyles
  };
}

const labelToPaddingPlacement = {
  top: 'Bottom',
  bottom: 'Top',
  left: 'Right',
  right: 'Left'
};

function getLabelStyle(styleArgs) {
  const {
    hasLabel,
    $theme: theme,
    $disabled: disabled,
    $labelPlacement: labelPlacement = 'right'
  } = styleArgs;
  const paddingPlacement = labelToPaddingPlacement[labelPlacement];
  const padding = hasLabel ? {
    [`padding${paddingPlacement}`]: '1rem'
  } : {};
  return {
    color: disabled ? theme.colors.grey40 : theme.colors.grey70,
    fontSize: '1rem',
    ...padding
  };
}

function getRootStyle(styleArgs) {
  const {
    $labelPlacement: labelPlacement
  } = styleArgs;
  return {
    alignItems: labelPlacement === 'top' || labelPlacement === 'bottom' ? 'flex-start' : 'center',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  };
}

function getInputStyle() {
  // Baseui uses `position: absolute` on the input, which causes weird scroll
  // behavior in some browsers because the input is positioned in a random place.
  // Switching it to display: none resolves this issue
  return {
    position: 'static',
    display: 'none'
  };
}

function getOverrides(options) {
  return {
    Checkmark: {
      style: styleArgs => getCheckmarkStyle({ ...styleArgs,
        ...options
      })
    },
    Label: {
      style: styleArgs => getLabelStyle({ ...styleArgs,
        ...options
      })
    },
    Input: {
      style: getInputStyle
    },
    Root: {
      style: styleArgs => getRootStyle({ ...styleArgs,
        ...options
      })
    }
  };
}